import React, { useCallback } from 'react'
import styled from 'styled-components/macro'
import { Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { PolicyCreateForm } from '@tomfxs/permissions-client'
import { PolicyJSON } from '@tomfxs/permissions-core'
import RouteContainer from 'src/components/App/RouteContainer'

const StyledHeading = styled(Typography)`
    margin-bottom: ${({ theme }) => theme.spacing(1)};
`

export function PermissionsCreateRoute() {
    const navigate = useNavigate()

    const onCreate = useCallback(
        (policy: PolicyJSON) => {
            navigate(`/settings/permissions/${policy._id}`)
        },
        [navigate],
    )

    return (
        <RouteContainer>
            <StyledHeading variant="h4">Berechtigungs-Richtlinie erstellen</StyledHeading>
            <PolicyCreateForm onCreated={onCreate} />
        </RouteContainer>
    )
}
